// ** React Imports
import { SyntheticEvent, useState } from 'react'

// ** MUI Imports
import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'
import Grid from '@mui/material/Grid'

// ** Custom Components Imports
import CustomProfileCard from 'src/components/aboutus/CustomProfileCard'

const CustomVerticalTab = () => {
  // ** State
  const [value, setValue] = useState<string>('1')

  const handleChange = (event: SyntheticEvent, newValue: string) => {
    setValue(newValue)
  }

  return (
    <TabContext value={value}>
      <Grid container>
        <Grid item xs={4} lg={3}>
          <TabList orientation='vertical' onChange={handleChange} aria-label='Jajaran Pengurus & Pejabat Eksekutif'
            sx={{
              '& .MuiTabs-flexContainer': {
              },
              '& button': {
                width: '100%',
                textTransform: 'capitalize',
                textAlign: 'start',
                '& .MuiTouchRipple-root': {
                  color: theme => theme.palette.secondary.main,
                },
              },
              '& .Mui-selected': {
                fontWeight: 600,
              },
              '& .MuiTab-root': {
                alignItems: 'flex-start',
              },
              '& .MuiTabs-indicator': {
                width: '6px',
                backgroundColor: theme => theme.palette.secondary.main,
                left: 0,
              }
            }}>
            <Tab value='1' label='Dewan Komisaris' />
            {/* <Tab value='2' label='Dewan Pengawas Syariah' /> */}
            <Tab value='3' label='Direksi' />
            {/* <Tab value='4' label='Pejabat Eksekutif' /> */}
          </TabList>
        </Grid>
        <Grid item xs={8} lg={9}>
          <TabPanel value='1'>
            <Grid container rowSpacing={8} justifyContent='center'>
              <Grid item xs={12} sm={6} lg={12}>
                <CustomProfileCard nama={`Prof. Dr. Eny Rochaida, SE., M.Si`} jabatan={`Plt. Komisaris Utama`} foto={`https://bankaltimtara.co.id/assets/file_lib/photo_direksi_dan_komisaris_web_20des2023_bu_enipng.png`} />
                </Grid>
              <Grid item xs={12} sm={6} lg={4}>
                <CustomProfileCard nama={`Dr. Bela Barus, SE. MMT.`} jabatan={`Komisaris Independen`} foto={`https://bankaltimtara.co.id/assets/file_lib/photo_direksi_dan_komisaris_web_20des2023_pak_baruspng.png`} />
              </Grid>
              <Grid item xs={12} sm={6} lg={4}>
                <CustomProfileCard nama={`Suriansyah`} jabatan={`Komisaris Non Independen`} foto={`https://bankaltimtara.co.id/assets/file_lib/photo_direksi_dan_komisaris_web_20des2023_pak_suriansyahpng.png`} />
              </Grid>
              <Grid item xs={12} sm={6} lg={4}>
                <CustomProfileCard nama={`Riza Indra Riadi`} jabatan={`Komisaris Non Independen`} foto={`https://bankaltimtara.co.id/assets/file_lib/photo_direksi_dan_komisaris_web_20des2023_pak_rizapng.png`} />
              </Grid>
              {/* <Grid item xs={12} sm={12} lg={6}>
                <CustomProfileCard nama={`Zainuddin Fanani`} jabatan={`Komisaris Utama`} foto={`https://bankaltimtara.co.id/assets/file_lib/photo_web_kamut_pak_zai_06apr2022png.png`} />
              </Grid> */}
              {/* <Grid item xs={12} sm={6} lg={4}>
                <CustomProfileCard nama={`Prof. Dr. Eny Rochaida, SE., M.Si`} jabatan={`Komisaris Independen`} foto={`https://bankaltimtara.co.id/assets/file_lib/eny_r_webpng.png`} />
              </Grid> */}
            </Grid>
          </TabPanel>
          <TabPanel value='2'>

          </TabPanel>
          <TabPanel value='3'>
            <Grid container rowSpacing={8} justifyContent='center'>
              <Grid item xs={12} sm={6} lg={12}>
                <CustomProfileCard nama={`Muhammad Yamin`} jabatan={`Direktur Utama`} foto={`https://bankaltimtara.co.id/assets/file_lib/photo_direksi_dan_komisaris_web_20des2023_pak_yaminpng.png`} />
              </Grid>
              <Grid item xs={12} sm={6} lg={4}>
                <CustomProfileCard nama={`Siti Aisyah`} jabatan={`Direktur Kredit`} foto={`https://bankaltimtara.co.id/assets/file_lib/photo_direksi_dan_komisaris_web_20des2023_bu_aaypng.png`} />
              </Grid>
              <Grid item xs={12} sm={6} lg={4}>
                <CustomProfileCard nama={`Muhammad Edwin`} jabatan={`Direktur Bisnis & Syariah`} foto={`https://bankaltimtara.co.id/assets/file_lib/photo_direksi_dan_komisaris_web_20des2023_pak_edwinpng.png`} />
              </Grid>
              <Grid item xs={12} sm={6} lg={4}>
                <CustomProfileCard nama={`Yenny Israwati`} jabatan={`Direktur Operasional & Manajemen Risiko`} foto={`https://bankaltimtara.co.id/assets/file_lib/photo_direksi_dan_komisaris_web_20des2023_bu_yennypng.png`} />
              </Grid>
              {/* <Grid item xs={12} sm={6} lg={4}>
                <CustomProfileCard nama={`Andi Hadiwijaya`} jabatan={`Direktur Kepatuhan & Human Capital`} foto={`https://bankaltimtara.co.id/assets/file_lib/andi_hadiwijaya_webpng.png`} />
              </Grid> */}
            </Grid>
          </TabPanel>
          <TabPanel value='4'>

          </TabPanel>
        </Grid>
      </Grid>
    </TabContext>
  )
}

export default CustomVerticalTab
